<button class="btn-root">
  <div class="btn-inner">Dummy Button</div>
</button>
